import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import SecurityRemarksPageUI from './SecurityRemarksPageUI.js'

class SecurityRemarksPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      securityRemarksList: null,
      objectCode: null,
      objectId: null,
      createMode: false,
      updateRemarksMode: false
    }
  }

  render() {
    return (
      <SecurityRemarksPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        objectCode={this.state.objectCode}
        objectId={this.state.objectId}
        createMode={this.state.createMode}
        updateRemarksMode={this.state.updateRemarksMode}
        onCancelRemarksClick={() => { this.setState({ createMode: false, updateRemarksMode: false }) }}
        onCreateRemarksClick={this.onCreateRemarksClick}
        onUpdateRemarksClick={this.onUpdateRemarksClick}
        selectedDate={this.state.selectedDate}
        selectedRemarks={this.state.selectedRemarks}
        selectedRemarksId={this.state.selectedRemarksId}
        securityRemarksList={this.state.securityRemarksList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getSecurityRemarks(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getSecurityRemarks(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/objectCode/security/remarks`,
      cacheKey: CacheKeys.LoanRemarks(this.props.match.params.loanId, 'security'),
      callback: this.getSecurityRemarksCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getSecurityRemarksCallback = (response) => {
    this.setState({ errorList: response.errorList, securityRemarksList: response.remarksList })
  }

  onCreateRemarksClick = (event) => {
    let objectCode = event.currentTarget.getAttribute('data-object-code')
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      createMode: true,
      objectCode: objectCode,
      objectId: objectId
    })
  }

  onUpdateRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    let date = event.currentTarget.getAttribute('data-date')
    let selectedRemarks = event.currentTarget.getAttribute('data-remarks')
    let selectedRemarksId = event.currentTarget.getAttribute('data-remarks-id')

    this.setState({
      updateRemarksMode: true,
      objectId: objectId,
      createMode: false,
      selectedDate: date,
      selectedRemarks: selectedRemarks,
      selectedRemarksId: selectedRemarksId
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.state.loan.loanId))
    CacheManager.removeObject(CacheKeys.LoanRemarks(this.props.match.params.loanId, 'security'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
      this.getSecurityRemarks(context)
    }
    else {
      this.setState({
        loan: null,
        securityRemarksList: null,
        errorList: null
      })
      this.getLoan(context)
      this.getSecurityRemarks(context)
    }
  }
}

export default withRouter(SecurityRemarksPageSF)
